/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const CustomerDetailPage = lazyLoad(
  () => import('./index'),
  module => module.CustomerDetailPage
);
